import { render, staticRenderFns } from "./ManagementDetail.vue?vue&type=template&id=26e3546a&scoped=true&"
import script from "./ManagementDetail.vue?vue&type=script&lang=js&"
export * from "./ManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManagementDetail.vue?vue&type=style&index=0&id=26e3546a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e3546a",
  null
  
)

export default component.exports